<template>
    <div
        class="t-select t-input"
        @click="visibleList = !visibleList"
        ref="selectRef"
    >
        <div class="t-select__head">
            <div
                class="t-select__multiple-values"
                v-if="multiple"
            >
                <span
                    class="t-select__multiple-values-item "
                    v-for="(value, index) in values"
                    @click="handleDeleteOption(value)"
                >{{ options[value] }}</span>
            </div>
            <input
                v-else
                class="t-select__input"
                :value=" options[value]"
                :disabled="true"
            >
            <svg class="t-select__arrow" :class="{_open: visibleList}" width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.13455 4.84913L0 0.728442L0.730893 0L4.5 3.75647L8.26911 0L9 0.728442L4.86545 4.84913C4.66362 5.05029 4.33638 5.05029 4.13455 4.84913Z" fill="#C8C8C8"/>
            </svg>
        </div>
        <transition name="fade">
            <ul v-if="visibleList" class="t-select__list" @click.stop>
                <li
                    v-for="(name, option) in options"
                    class="t-select__item"
                    :class="{_active: value === option || values.includes(option) }"
                    :key="`data-select-list-${option}`"
                    @click="handleClickValue(option)"
                >
                    {{ name }}
                    <svg class="t-select__check" width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.4232 0.945312L11.3346 1.6368L4.83112 7.88175C4.71542 7.99286 4.54958 8.05642 4.37542 8.05642C4.20127 8.05642 4.03543 7.99286 3.91972 7.88175L0.667969 4.75928L1.57937 4.06779L4.37542 6.75269L10.4232 0.945312Z" fill="#00b0bd"/>
                    </svg>
                </li>
            </ul>
        </transition>
  </div>
</template>

<script>
  import Vue from 'vue';

  export default {
      name: "lk-leads-select",
      props: {
          value: String,
          values: {
            type: Array,
            default: () => []
          },
          options: {
              type: Object,
              default: () => ({}),
          },
          data: Object,
          multiple: {
              type: Boolean,
              default: false
          },
          addTo: {
              type: Number,
              default: 0
          },
          className: {
              type: String,
              default: ''
          },
      },
      data() {
          return {
              visibleList: false,
          }
      },
      methods: {
            handleClickValue (option) {
                if (!this.multiple) {
                    this.$emit('update:value', option)    
                    this.visibleList = false
                    return;
                }

                const isValueExists = this.values.includes(option);
                
                const newValues = isValueExists
                    ? this.values.filter(v => v !== option)
                    : [ ...this.values, option ]

                this.$emit('update:values', newValues)
            },
            handleDeleteOption (option) {
                this.$emit('update:values', this.values.filter(v => v !== option))
            },
          closeList(e) {

              const elem = this.$refs['selectRef'];

              if (!elem) return;

              const target = e.target;
              const its = target === elem || elem.contains(target);
              if (!its && this.visibleList) {
                  this.visibleList = false;
              }
          },
          deleteValue(index, id) {
              this.data.value.splice(index, 1);
              this.name = this.data.value.length ? ' ' : '';

              this.data.list.forEach(item => {
                  if (item.id === id) {
                      Vue.set(item, 'active', false);
                  }
              });
          },
          clearSelect() {
              this.data.list.forEach((item) => {
                  Vue.set(item, 'active', false);
              });
          },
      },
      mounted() {
          document.addEventListener('click', this.closeList);
      },
      beforeDestroy() {
          document.removeEventListener('click', this.closeList);
      }
  }
</script>



// WEBPACK FOOTER //
// src/templates/components/lk/lk-leads-select/lk-leads-select.vue